export const ADMIN_ADD_PREWORKS = 'ADMIN_ADD_PREWORKS'
export const ADMIN_UPDATE_PREWORKS = 'ADMIN_UPDATE_PREWORKS'
export const ADMIN_GET_PREWORKS = 'ADMIN_GET_PREWORKS'
export const ADMIN_GET_PREWORKS_LIST = 'ADMIN_GET_PREWORKS_LIST'